export default __webpack_public_path__ + "static/similarity-dont-5960953b1cf13d4a923a02a7f8951b60.png";